const orangeA = {
  orangeA1: "hsla(0, 0%, 0%, 0)",
  orangeA2: "hsla(13, 100%, 49.7%, 0.054)",
  orangeA3: "hsla(20, 100%, 49.7%, 0.117)",
  orangeA4: "hsla(23, 100%, 49.8%, 0.166)",
  orangeA5: "hsla(23, 99.4%, 50.1%, 0.215)",
  orangeA6: "hsla(23, 99.8%, 51.1%, 0.286)",
  orangeA7: "hsla(23, 99.7%, 50.6%, 0.389)",
  orangeA8: "hsla(24, 100%, 49.9%, 0.523)",
  orangeA9: "hsla(24, 99.9%, 51.6%, 0.965)",
  orangeA10: "hsla(25, 100%, 58.6%, 0.980)",
  orangeA11: "hsla(24, 100%, 62.4%, 0.980)",
  orangeA12: "hsla(26, 100%, 94.2%, 0.980)"
};
export { orangeA };
//# sourceMappingURL=orangeA.mjs.map
